import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import axios from "../lib/AxiosGo";
import { toast } from "react-toastify";

const ReportPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/reports/data");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching report data:", error);
      toast.error("Gagal mengambil data laporan");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (reportId) => {
    if (!window.confirm("Apakah Anda yakin ingin menghapus data laporan ini?")) return;
    try {
      await axios.delete(`/reports/${reportId}`);
      toast.success("Laporan berhasil dihapus!");
      getData();
    } catch (error) {
      console.error("Error deleting report:", error);
      toast.error("Gagal menghapus laporan");
    }
  };

  const handleDownload = (filePath) => {
    if (!filePath) return;
    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000/";
    const base = apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`;
    window.open(`${base}reports/attachment?path=${encodeURIComponent(filePath)}`, "_blank");
  };

  const handleDownloadLetter = (reportId) => {
    if (!reportId) return;
    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000/";
    const base = apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`;
    window.open(`${base}reports/export-pdf?reportId=${reportId}`, "_blank");
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Laporan Pengaduan Masyarakat (Subdit Renakta Polda)" />
        <div className="card h-100 radius-12 border-0 shadow-sm">
          <div className="card-header py-16 px-24 bg-base d-flex align-items-center justify-content-between border border-end-0 border-start-0 border-top-0">
            <div>
              <h5 className="card-title text-lg text-primary-light mb-0">
                Daftar Laporan Masuk via WhatsApp Bot
              </h5>
              <p className="text-xs text-muted mb-0">Laporan tindak pidana dan pengaduan masyarakat yang terverifikasi</p>
            </div>
            <button
              onClick={getData}
              className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1 radius-8 px-12"
            >
              <Icon icon="mdi:refresh" /> Refresh Data
            </button>
          </div>
          <div className="card-body p-16">
            <div className="table-responsive">
              <table className="table border-primary-table mb-0 align-middle">
                <thead>
                  <tr>
                    <th>Surat Resmi</th>
                    <th>Pelapor</th>
                    <th>Jenis Kejahatan</th>
                    <th>Detail Kronologi Kasus</th>
                    <th>TKP / Lokasi</th>
                    <th>Nama & Usia Korban</th>
                    <th>Hubungan</th>
                    <th>Identitas Terduga Pelaku</th>
                    <th>Bukti / Lampiran</th>
                    <th>Persetujuan</th>
                    <th className="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="11" className="text-center py-32 text-muted">
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                        Memuat data laporan...
                      </td>
                    </tr>
                  ) : data.length > 0 ? (
                    data.map((report) => (
                      <tr key={report.id || report.report_id}>
                        <td>
                          <button
                            className="btn btn-xs btn-danger d-inline-flex align-items-center gap-1 radius-6"
                            onClick={() => handleDownloadLetter(report.id || report.report_id)}
                            title="Download PDF Surat Laporan Resmi"
                          >
                            <Icon icon="mdi:file-pdf-box" className="text-base" /> Cetak PDF
                          </button>
                        </td>
                        <td>
                          <strong className="text-primary-light">{report.reporter?.full_name || "Masyarakat"}</strong>
                          <span className="text-xs text-muted d-block">{report.reporter?.phone || report.reporter?.no_wa || "-"}</span>
                        </td>
                        <td>
                          <span className="badge bg-primary-50 text-primary-700 px-8 py-4 radius-6">
                            {report.report_type_of_crime || "Pengaduan Umum"}
                          </span>
                        </td>
                        <td style={{ maxWidth: "200px" }} className="text-truncate" title={report.report_case}>
                          {report.report_case || "-"}
                        </td>
                        <td>{report.report_location || "-"}</td>
                        <td>
                          {report.report_victim_name || "-"}
                          {report.report_victim_age ? ` (${report.report_victim_age} thn)` : ""}
                        </td>
                        <td>{report.report_victim_relation || "-"}</td>
                        <td style={{ maxWidth: "150px" }} className="text-truncate" title={report.report_identity_perpetrator}>
                          {report.report_identity_perpetrator || "-"}
                        </td>
                        <td>
                          {report.report_attachment ? (
                            <button
                              onClick={() => handleDownload(report.report_attachment)}
                              className="btn btn-xs btn-outline-info d-inline-flex align-items-center gap-1 radius-6"
                              title="Unduh Berkas Lampiran"
                            >
                              <Icon icon="mdi:paperclip" /> Unduh Berkas
                            </button>
                          ) : (
                            <span className="text-xs text-muted">Tidak Ada</span>
                          )}
                        </td>
                        <td>
                          {report.report_agreement_reporter ? (
                            <span className="badge bg-success-50 text-success-700 px-8 py-4 radius-6">
                              <Icon icon="mdi:check" className="me-1" /> Disetujui
                            </span>
                          ) : (
                            <span className="badge bg-danger-50 text-danger-700 px-8 py-4 radius-6">
                              Belum Setuju
                            </span>
                          )}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-xs btn-outline-danger d-inline-flex align-items-center gap-1 radius-6"
                            onClick={() => handleDelete(report.id || report.report_id)}
                            title="Hapus Laporan"
                          >
                            <Icon icon="iconamoon:trash-fill" /> Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center py-24 text-muted">
                        Belum ada laporan pengaduan masuk.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ReportPage;
